import React, { useState } from 'react';
import Icon from '@mdi/react';
import { mdiCheckCircle, mdiKey, mdiChevronDown, mdiChevronUp } from '@mdi/js';
import { checkMedia } from '../../../app/common/helpers/othersHelpers';

export default function MViewSummaryAnswerFormListItems({
  state,
  question,
  onChangeInput,
  handleEnter,
  isEdit,
  roundNumber,
}) {
  const [showMore, setShowMore] = useState(false);
  let item = state?.[0] && state.find((i) => i.key + '' === question.key + '');

  let optionQuestion =
    question?.questionType === 'optionQuestion' ||
    question?.questionType === 'rightWrongQuestion'
      ? true
      : false;
  let isShortLongQuestion =
    question &&
    (question.questionType === 'shortQuestion' ||
      question.questionType === 'longQuestion')
      ? true
      : false;
  let options = question?.options;
  let detailOptions = question?.detailOptions;

  let isChecked = item?.isCorrect ? (
    <span className='icon is-small has-text-info ml-1'>
      <Icon path={mdiCheckCircle} size={0.8} />
    </span>
  ) : (
    ''
  );

  let questionDetail = optionQuestion ? (
    <>
      <style>{`.custom-ck-content p { margin-bottom: 0 !important; }`}</style>
      <p
        className='ck-content custom-ck-content ml-2'
        dangerouslySetInnerHTML={{
          __html: checkMedia({
            string: question?.question,
          }),
        }}
        style={{ marginBottom: 4 }}
      ></p>
      <div>
        <button
          className='button is-small is-light is-rounded'
          onClick={() => setShowMore(!showMore)}
        >
          <span>{showMore ? 'Sembunyikan Pilihan' : 'Tampilkan Pilihan'}</span>
          <span className='icon is-small'>
            <Icon path={showMore ? mdiChevronUp : mdiChevronDown} size={1} />
          </span>
        </button>
      </div>
      {showMore && (
        <div
          style={{
            marginTop: 10,
            display: 'flex',
            flexWrap: 'wrap',
            gap: '8px',
          }}
        >
          {options.map((i, index) => (
            <div
              key={index}
              className='c-tag'
              style={{
                display: 'inline-flex',
                alignItems: 'flex-start',
                justifyContent: 'flex-start',
              }}
            >
              <div>{i}.</div>
              {detailOptions && (
                <div
                  className='ck-content custom-ck-content ml-2'
                  dangerouslySetInnerHTML={{
                    __html: checkMedia({
                      string: detailOptions?.[i]
                        ? ` ${detailOptions?.[i]}`
                        : '',
                    }),
                  }}
                ></div>
              )}
            </div>
          ))}
        </div>
      )}
    </>
  ) : (
    <div
      className='ck-content'
      dangerouslySetInnerHTML={{
        __html: checkMedia({ string: question?.question }),
      }}
    ></div>
  );

  let fnSc =
    item?.finalScore &&
    !isNaN(item?.finalScore) &&
    !Number.isNaN(item?.finalScore)
      ? roundNumber(item?.finalScore)
      : 0;

  function addSpaceAroundCertainChars(str) {
    if (typeof str !== 'string') {
      return str;
    }
    return str.replace(/([^=])=([^=])/g, '$1 = $2');
  }

  return (
    <tr>
      <td className='has-text-centered middle'>{item?.no}</td>
      <td className='middle'>{questionDetail}</td>
      <td className='middle'>
        <span className='flex align-center'>
          {item?.stAns && item?.stAns !== ''
            ? addSpaceAroundCertainChars(item?.stAns)
            : ''}{' '}
          {isChecked}{' '}
          {!isShortLongQuestion && !item?.isCorrect && (
            <span className='c-tag ml-2'>0</span>
          )}
          {isShortLongQuestion &&
            !item?.isCorrect &&
            (item?.score === 0 || item?.score || !isNaN(item?.score)) && (
              <span className='c-tag ml-2'>
                {item?.score &&
                  Math.round((item?.score + Number.EPSILON) * 100) / 100}
              </span>
            )}
        </span>{' '}
        <div className='mt-2'>
          <span className='c-tag' style={{ position: 'relative' }}>
            <span
              className='icon is-small'
              style={{ position: 'absolute', top: 2 }}
            >
              <Icon path={mdiKey} size={1} />
            </span>
            <span style={{ marginLeft: 20 }}>: {item?.keyAns}</span>
          </span>
        </div>
      </td>
      <td className='middle has-text-right'>
        {!isEdit && fnSc}
        {isEdit && (
          <TextInput
            name={item?.no + '_score'}
            style={{ textAlign: 'right', width: '90%', height: 30 }}
            defaultValue={item?.finalScore ?? 0}
            onKeyDown={(e) => handleEnter(e)}
            onChange={(e) => onChangeInput(e, item, question.questionType)}
            placeholder='ex: 80'
            label='noLabel'
          />
        )}
      </td>
    </tr>
  );
}

const TextInput = ({
  name,
  type,
  onChange,
  onKeyDown,
  disabled,
  readOnly,
  defaultValue,
  placeholder,
  label,
  style,
}) => (
  <div className='field'>
    {label !== 'noLabel' && (
      <label className='label' htmlFor={name}>
        {label}
      </label>
    )}
    <div className='control'>
      <input
        className='input is-size-6'
        id={name}
        readOnly={readOnly}
        onChange={onChange}
        onKeyDown={onKeyDown}
        value={defaultValue}
        type={type}
        disabled={disabled}
        placeholder={placeholder}
        style={{ ...style }}
      />
    </div>
  </div>
);
